import axios from "axios";
import { http } from "@/lib/http";
export function fetchMessages() {
  return http.get("/api/messages/get_all?limit=100").then((res) => res.data);
}
export function fetchMessage(id) {
  return fetchMessages().then((list) => list.find((m) => m._id === id) ?? null);
}
export function addMessage(payload) {
  return http.post("/api/messages/add", payload).then((res) => res.data);
}
export function editMessage(id, payload) {
  return http.post(`/api/messages/edit/${id}`, payload).then((res) => res.data);
}
export function sendGuidNotification(payload) {
  return http
    .post("/api/notifications/send_notif/guid", payload)
    .then((res) => res.data);
}
export function listTemplates() {
  return http.get("/api/messages/list_templates").then((res) => res.data);
}
export function addTemplate(payload) {
  return http
    .post("/api/messages/addTemplate", payload)
    .then((res) => res.data);
}
export function deleteTemplate(id) {
  return http
    .delete(`/api/messages/delete_template/${id}`)
    .then((res) => res.data);
}
export function fetchOutletBranches() {
  const base = import.meta.env.VITE_HOST_DOMAIN;
  if (!base)
    return Promise.reject(new Error("VITE_HOST_DOMAIN not configured"));
  return axios
    .post(`${base}/esc/transactions/get_branches`)
    .then((res) => res.data?.stores ?? []);
}
export function fetchMessageReadNames(id) {
  return http
    .post("/api/messages/get_names", { docId: id })
    .then((res) => res.data);
}
export function deleteMessage(id) {
  return http.delete(`/api/messages/delete/${id}`).then((res) => res.data);
}
